<template>
  <div class="error">
    <article class="message is-danger">
      <div class="message-body">
        <span class="icon"><i class="fal fa-exclamation-triangle" aria-hidden="true"></i></span>
        {{message}}
        <div><button class="button" @click="retry">{{ $t('retry') }}</button></div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: ['retry', 'message']
}
</script>

<style lang="scss" scoped>
  .error {
    padding: 1rem;
    height: 100%;
    text-align: center;

    button {
      margin-top: 0.5rem;
    }

    &.editor {
      padding: 35vh 5rem;
    }
  }
</style>
